export let TableId = /*#__PURE__*/function (TableId) {
  TableId["STANDARD"] = "standard";
  TableId["AGENCY"] = "agency";
  return TableId;
}({});
export let OptionId = /*#__PURE__*/function (OptionId) {
  OptionId["STARTER"] = "starter";
  OptionId["CORE"] = "core";
  OptionId["PREMIUM"] = "premium";
  OptionId["AGENCY_STARTER"] = "agency_starter";
  OptionId["AGENCY_SMALL"] = "agency_small";
  OptionId["AGENCY_MEDIUM"] = "agency_medium";
  OptionId["AGENCY_LARGE"] = "agency_large";
  OptionId["AGENCY_HUGE"] = "agency_huge";
  return OptionId;
}({});
export let LimitId = /*#__PURE__*/function (LimitId) {
  LimitId["STORIES"] = "stories";
  LimitId["USERS"] = "users";
  LimitId["SITES"] = "sites";
  LimitId["CONTACTS"] = "contacts";
  LimitId["EMAIL_SENDS"] = "email_sends";
  LimitId["CUSTOM_SENDER_ADDRESSES"] = "custom_sender_addresses";
  return LimitId;
}({});
export let AddOnId = /*#__PURE__*/function (AddOnId) {
  AddOnId["SITE"] = "site";
  return AddOnId;
}({});
export let CellType = /*#__PURE__*/function (CellType) {
  CellType["TEXT"] = "text";
  CellType["PRICING"] = "pricing";
  return CellType;
}({});